// src/pages/Admin/TableauDeBordAdherents/hooks/useAdminDashboardAccess.js

import { useMemo } from "react";
import { useUser } from "../../../Home/UserContext";
import {
  getStoredUserInfo,
  getUserRoleId,
} from "../utils/adminDashboardUtils";

export function useAdminDashboardAccess() {
  const { user } = useUser();

  const storedUser = useMemo(() => getStoredUserInfo(), []);

  const resolvedUser = user || storedUser;

  const roleId = useMemo(() => {
    return getUserRoleId(resolvedUser);
  }, [resolvedUser]);

  return {
    user: resolvedUser,
    roleId,
    isAdmin: roleId === 1,
  };
}